package game.entity

import game.Game
import game.Room
import game.TileType
import kotlin.math.absoluteValue
import kotlin.math.sign
import kotlin.random.Random

enum class ImpType(val spriteId: String, val speed: Int, val hp: Int, val damage: Int) {
    GreyImp("imp", 6, 1, 1),
    RedImp("red-imp", 5, 3, 1)
}

class Imp(val impType: ImpType): Enemy(impType.hp, impType.damage) {
//    var speed = 6
    var moveCoolDown = 0
    var chaseCoolDown = 0
    var destCol = 0
    var destRow = 0

    override fun onInit(game: Game, room: Room) {
        if (sprite == null) {
            sprite = game.getSpriteById(impType.spriteId)
        }
    }

    override fun onTick(game: Game, room: Room) {
        if (moveCoolDown != 0) {
            moveCoolDown--
        } else {
            if (chaseCoolDown != 0) {
                chaseCoolDown--
                val deltaCol = destCol - col
                val deltaRow = destRow - row
                var destCol = col
                var destRow = row

                if (deltaCol.absoluteValue > deltaRow.absoluteValue) {
                    destCol += deltaCol.sign
                    if (room[destCol, destRow].type != TileType.Floor) {
                        destCol -= deltaCol.sign
                        destRow += deltaRow.sign
                    }
                } else {
                    destRow += deltaRow.sign
                    if (room[destCol, destRow].type != TileType.Floor) {
                        destRow -= deltaRow.sign
                        destCol += deltaCol.sign
                    }
                }

                val entity = room.getEntityAt(destCol, destRow)
                if (entity == null && room[destCol, destRow].type == TileType.Floor) {
                    col = destCol
                    row = destRow
                } else if (entity?.type == "cactus") {
                    col = destCol
                    row = destRow
                    takeDamage(game, 1)
                }
                moveCoolDown = impType.speed
            } else {
                destCol = game.player.col
                destRow = game.player.row

                chaseCoolDown = Random.nextInt(8, 12)
            }
        }
    }
}